import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'team',
  name: fr.title,
  description: fr.description,
  icon: 'users',
  color: '#0F766E',
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: { uses: ['app.records.read', 'app.records.write'], defines: [] },
  entities: {
    uses: [],
    owns: [
      { table: 'plans', scope: 'workspace', description: fr.description },
      { table: 'receipts', scope: 'workspace', description: fr.history },
      { table: 'forecasts', scope: 'workspace', description: fr.forecastTitle },
    ],
  },
  events: { emits: emitsOf(events), subscribes: [] },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['team.seed'], conditions: ['team.ready'], blocks: [] },
  migrations: { schema: 'app_team', dir: 'migrations' },
});
